module.exports = __webpack_public_path__ + "img/partners-icon16.055bef54.jpg";